import { Outlet } from "react-router-dom";
import React from "react";
import Footer from "../Components/Layout/Footer";
import TopNavigation from "../Components/Layout/TopNavigation";
import WebNotification from "../Components/WebNotification";
import Alert from "../Components/Alert";
import ReleaseAnnouncementManager from "../Components/Announcement/ReleaseAnnouncementManager";

export default function AppLayout({ vonWarning }) {
    return (
        <div className="App">
            <TopNavigation/>
            <ReleaseAnnouncementManager/>
            <WebNotification/>
            <Alert/>
            <div>
                <div className="container-fluid">
                    <Outlet/>
                </div>
            </div>
            {vonWarning && <VonWarning/>}
            <Footer/>
        </div>
    );
}

const VonWarning = () => {
    return <div className="alert" role="alert">
        <div>
            <span className="vismaicon vismaicon-lg vismaicon-filled vismaicon-error" aria-hidden="true"></span>
            <strong>Can´t access VON</strong> Information and functionality is limited.
        </div>
    </div>
}
